const SKIP_KEYS = new Set(['stock', 'barcode', 'price', 'sku', 'name', 'value']);
const COLOR_KEYS = new Set(['color', 'Color', 'RENK', 'renk', 'Renk', 'colour', 'Colour', 'Farbe']);
const SIZE_KEYS = new Set(['size', 'Size', 'BEDEN', 'beden', 'Beden', 'Größe', 'Groesse']);

const LABELS = {
  color: 'Renk',
  Color: 'Renk',
  RENK: 'Renk',
  renk: 'Renk',
  Renk: 'Renk',
  colour: 'Renk',
  Colour: 'Renk',
  Farbe: 'Renk',
  size: 'Beden',
  Size: 'Beden',
  BEDEN: 'Beden',
  beden: 'Beden',
  Beden: 'Beden',
  Größe: 'Beden',
  Groesse: 'Beden',
  barcode: 'Barkod',
  sku: 'SKU',
};

export function collectVariantGroups(product) {
  if (!product) return {};
  const variantGroups = {};
  const variants = Array.isArray(product.variants) ? product.variants : [];

  if (variants.length > 0) {
    const variantKeys = [
      ...new Set(variants.flatMap((v) => Object.keys(v || {}).filter((k) => !SKIP_KEYS.has(k)))),
    ];
    variantKeys.forEach((key) => {
      const uniqueValues = [...new Set(variants.map((v) => v?.[key]).filter(Boolean))];
      if (uniqueValues.length > 0) variantGroups[key] = uniqueValues;
    });

    if (Object.keys(variantGroups).length === 0) {
      const byName = {};
      variants.forEach((v) => {
        if (v?.name && v?.value) {
          if (!byName[v.name]) byName[v.name] = new Set();
          byName[v.name].add(v.value);
        }
      });
      Object.entries(byName).forEach(([name, values]) => {
        variantGroups[name] = [...values];
      });
    }
  }

  const hasColor = Object.keys(variantGroups).some((k) => COLOR_KEYS.has(k));
  if (Array.isArray(product.colors) && product.colors.length > 0 && !hasColor) {
    variantGroups.color = product.colors;
  }
  const hasSize = Object.keys(variantGroups).some((k) => SIZE_KEYS.has(k));
  if (Array.isArray(product.sizes) && product.sizes.length > 0 && !hasSize) {
    variantGroups.size = product.sizes;
  }
  return variantGroups;
}

export function productNeedsVariant(product) {
  return Object.keys(collectVariantGroups(product)).length > 0;
}

/** Aynı renk+beden satırını ayırt eden anahtar. Barkod ve stok dahil değil. */
export function variantKey(variant) {
  if (!variant || typeof variant !== 'object') return '';
  return Object.keys(variant)
    .filter((k) => !SKIP_KEYS.has(k) && k !== 'name' && k !== 'value' && variant[k] != null && String(variant[k]).trim() !== '')
    .sort()
    .map((k) => `${k}:${variant[k]}`)
    .join('|');
}

export function formatSelectedVariant(variant, { includeCodes = false } = {}) {
  if (!variant) return '';
  if (typeof variant === 'string') return variant;
  const hide = new Set(['stock', 'price']);
  if (!includeCodes) {
    hide.add('barcode');
    hide.add('sku');
  }
  return Object.entries(variant)
    .filter(([k, v]) => !hide.has(k) && v != null && String(v).trim() !== '')
    .map(([k, v]) => `${LABELS[k] || k}: ${v}`)
    .join(' · ');
}

/** Ürün sayfasındaki seçimi, eşleşen varyantın barkoduyla birlikte sakla. */
export function selectionFromProduct(product, selected) {
  if (!selected || typeof selected !== 'object') return null;
  const clean = {};
  Object.entries(selected).forEach(([k, v]) => {
    if (k === 'stock' || k === 'price') return;
    if (v == null || String(v).trim() === '') return;
    clean[k] = v;
  });
  if (Object.keys(clean).length === 0) return null;
  const match = (product?.variants || []).find((row) =>
    Object.entries(clean).every(([k, v]) => String(row?.[k] ?? '') === String(v)),
  );
  if (match?.barcode) clean.barcode = match.barcode;
  if (match?.sku && !clean.sku) clean.sku = match.sku;
  return clean;
}
